export const SELECT_PLACEHOLDER = 'Included <PACKAGE> <NUMBER> *';
export const SELECT_PLACEHOLDER_NO_NUMBER = 'Included <PACKAGE> *';
export const SUBTITLE =
  'Select your food and drinks for your special day! On the day of the party, order additional food and drinks through your dedicated server. Ask about options for all ages!';
export const TITLE = 'Food & Drinks';
export const MISSING_SELECTION_ERROR = 'At least one item must be selected';
export const EXTRA_PLACEHOLDER = 'Extra <PACKAGE>';
export const REMOVE_EXTRA = 'Remove <PACKAGE>';
export const FLOATING_MESSAGE_ERROR = 'To continue, please select your pizza and drinks for your party';
